import AppForms from "@toothfairy/shared-ui/AppForms";
import AppInputLabel from "@toothfairy/shared-ui/AppInputLabel";
import dayjs from "dayjs";
import React from "react";
import { View } from "react-native";
import ToothFairyPeriodFilter from "../../../Components/ToothFairyComponents/ToothFairyPeriodFilter";

const SupportDateLeaf = ({ label = "" }) => {
  const { values, setFieldValue } = AppForms.useFormikContext();
  const selected = values?.activityDate
    ? new Date(values.activityDate)
    : dayjs().toDate();
  const handleUpdate = (date) =>
    setFieldValue("activityDate", (date || dayjs()).toISOString());
  return (
    <View style={{ alignSelf: "stretch", zIndex: 3 }}>
      <AppInputLabel label={label} isMandatory />
      <ToothFairyPeriodFilter
        selectsSingle
        startDate={selected}
        endDate={selected}
        onUpdateStartDate={handleUpdate}
        onUpdateEndDate={handleUpdate}
        paddingBottom={0}
      />
    </View>
  );
};

export default SupportDateLeaf;